import 'babel-polyfill'
import './cookie-wall.autoload'
